import React, { useEffect, useState } from 'react';
import BusinessUnitForm from './views/BusinessUnitForm';
import PageLayout from 'components/layout/PageLayout';
import { useTranslation } from 'react-i18next';
import { useDeleteBusinessUnitMutation, useGetBusinessUnitDetailQuery, useUpdateBusinessUnitMutation } from './api/businessUnitApiSlice';
import { Navigate, NavLink, useLocation } from 'react-router-dom';
import BusinessUnitDeleteModaButton from './views/BusinessUnitDeleteModalButton';
import BusinessUnitNav from './views/BusinessUnitNav';

const EditBusinessUnit = () => {

    const [t] = useTranslation("global")
    let location = useLocation()
    let businessUnitGuid = location.state

    const [isLocalized, setIsLocalized] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        code: '',
        latitude: null,
        longitude: null
    });

    // API
    const {
        data: response,
        isFetching,
        isLoading,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetBusinessUnitDetailQuery(businessUnitGuid)

    useEffect(() => {

        if (isSuccess) {
            console.log("New isSuccess into useEffect")
            const { businessUnit: data } = response
            setFormData({
                name: data.name,
                latitude: data.gps?.latitude || null,
                longitude: data.gps?.longitude || null,
                code: data.code
            });
            setIsLocalized(!!data.gps);
        }

    }, [isFetching]);


    // API
    const [updateBusinessUnit, {
        data: updateResult,
        isLoading: updateIsLoading,
        isSuccess: updateSuccess,
        reset: updateReset
    }] = useUpdateBusinessUnitMutation()

    // API
    const [deleteBusinessUnit, deleteBusinessUnitResult] = useDeleteBusinessUnitMutation()

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [id]: value
        }));
    };

    const handleLocationChange = (location) => {
        setFormData((prevData) => ({
            ...prevData,
            latitude: location.lat,
            longitude: location.lng,
        }));
        console.log("Picked Location:" + JSON.stringify(location))
    };

    const handleCheckboxChange = () => {
        setIsLocalized(!isLocalized);
    };

    const handeDelete = () => {
        deleteBusinessUnit(businessUnitGuid)
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const businessUnit = {
            guid: businessUnitGuid,
            name: formData.name,
            code: formData.code,
            gps: isLocalized ? {
                latitude: parseFloat(formData.latitude),
                longitude: parseFloat(formData.longitude)
            } : null
        };
        console.log('New Business Unit:', businessUnit);
        // Here you can make an API call to submit the business unit data
        updateBusinessUnit(businessUnit)
    };

    if (deleteBusinessUnitResult.isSuccess) {
        return <Navigate to="/dashboard/businessUnits" replace />
    }

    let content =

        <>
            {
                isSuccess &&
                <>
                    <BusinessUnitNav businessUnit={response.businessUnit} />
                    <div className='d-grid gap-2 d-flex justify-content-end p-2'>
                        <BusinessUnitDeleteModaButton businessUnitInfo={response} onDelete={handeDelete} />
                    </div>
                </>
            }

            <BusinessUnitForm
                formData={formData}
                submitted={updateSuccess}
                handleChange={handleChange}
                handleLocationChange={handleLocationChange}
                handleSubmit={handleSubmit}
                isLocalized={isLocalized}
                handleCheckboxChange={handleCheckboxChange}
            >
                <div className="alert alert-success">
                    Business Unit updated successfully!<br />
                    <NavLink className="btn btn-primary ml-3" to={"/dashboard/businessUnits"}>Back to catalog</NavLink>
                </div>
            </BusinessUnitForm>
        </>

    return <PageLayout
        pageTitle={t("entity.businessUnits")}
        onPageRefresh={refetch}
        bodyContent={content}
        isLoadingContent={isFetching}
        isLoadingPage={isLoading}
    />
};

export default EditBusinessUnit;